import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
const state = {
    suppliers:[],
    supplier : [],
    index:'',
    sortBy:'',
    sortDesc:''



};

const getters = {
    getSuppliers: state => {
        return state.suppliers;
    },
    getSupplier: state => {
        return state.supplier;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },
};

const actions = {

    asyncFetchData : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "suppliers";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);

        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['suppliers/getSortBy'],
                    'sortDesc': context.rootGetters['suppliers/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);
                context.commit('setSuppliers', res.data.data);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    fetchLists : async (context,settings) => {


        let url = "suppliers/lists";

        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);

                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },

    deleteSuppliers : async (context,settings) => {


        let url = "suppliers/delete";


        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "query": settings
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            }
        )

            .then(res => {
                //console.log(res.data.pagination);
                //context.commit('setCategories', res.data.data);
                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err.response.status);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
                return {error:err.response.status}
                //throw Error(err.response.status);
            });

    },


    getDetailSupplier : async (context,payload) =>{
        //console.log(payload)
        let url = `suppliers/detail/${payload}`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                //context.commit('setCategoriesTree', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
              /*  if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },

    destroyData : (context) =>{
        context.commit('setSuppliers',[]);
        context.commit('setSupplier',[]);



    },

    fetchSelect: async (context, settings) => {
        let url = 'suppliers/select';

        //console.log(context.rootGetters['categories/getSortBy'])
        return await axios
            .get(`${context.rootGetters['settings/getUrl']}${url}`, {
                headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
                'Content-Type': 'application/json',
            })

            .then(res => {
                //console.log(res.data.pagination);

                return res.data;
                //resolve(res);
            })
            .catch(err => {
                console.log('errore', err);
            });
    },

};

const mutations = {
    setSuppliers: (state,value) => {
        state.suppliers= value;
    },
    setSupplier: (state,value) => {
        state.supplier= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    }



};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
